import LZString from 'lz-string';
import Swal from 'sweetalert2/dist/sweetalert2.js'

const INVALIDATE_CACHE_CREATION_DATE = 1729636611039;

export const Toast = Swal.mixin({
    toast: true,
    position: 'bottom-right',
    iconColor: 'white',
    customClass: {
        popup: 'colored-toast',
    },
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
})


/**
 * 
 * Shorthand singular selector 
 * 
 */
export const $ = document.querySelector.bind(document);


/**
 * 
 * Shortand multiple selector
 * 
 */
export const $$ = document.querySelectorAll.bind(document);


/**
 * 
 * Get the pretty byte conversion on a string
 * 
 * @param {number} bytes 
 * @returns string
 */
export const formatBytes = (bytes) => {
    if (!+bytes) return '0 Bytes'
    const sizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
    const i = Math.floor(Math.log(bytes) / Math.log(1024))
    return `${parseFloat((bytes / Math.pow(1024, i)).toFixed(2))} ${sizes[i]}`
}

/**
 * 
 * Get the synthetic byte size of a string
 * 
 * @param {string} str 
 * @returns 
 */
export const byteSize = str => new Blob([str]).size;

// /**
//  * 
//  * Save an item to localStorage with an expiry time
//  * 
//  * @param {string} key 
//  * @param {array} value 
//  * @param {number} ttl 3600000 seconds = 1 hour
//  */
// export const setWithExpiry = (key, value, ttl = 3600000) => {

//     // Create a new item with an expiry time
//     const item = {
//         value: LZString.compressToUTF16(value),
//         expiry: new Date().getTime() + ttl
//     }

//     // Mitigate error where our local storage is full
//     try {

//         // Save the item to localStorage
//         localStorage.setItem(key, JSON.stringify(item));

//     } catch (error) {

//         console.log('Error saving to localStorage', error);

//     }

// }

export const setWithExpiry = (key, value, ttl = 3600000) => {
    return new Promise((resolve, reject) => {
        // Check if Web Worker is supported
        if (window.Worker) {
            // Create a new worker instance
            const worker = new Worker(`/_resources/themes/mercury/dist/compressionWorker.js`);

            // Set up the message event to receive data from the worker
            worker.onmessage = function (e) {
                const { key, compressedValue, ttl } = e.data;

                // Create a new item with an expiry time
                const item = {
                    value: compressedValue,
                    created: new Date().getTime(),
                    expiry: new Date().getTime() + ttl
                };

                // Try to save to localStorage
                try {
                    localStorage.setItem(key, JSON.stringify(item));

                    // Resolve the promise when the operation is successful
                    resolve(`Successfully saved ${key} to localStorage.`);

                } catch (error) {
                    // Reject the promise if saving fails
                    reject(new Error('Error saving to localStorage: ' + error));
                } finally {
                    worker.terminate(); // Stop the worker once the task is done
                }
            };

            // Handle worker errors
            worker.onerror = function (error) {
                reject(new Error('Worker error: ' + error.message));
                worker.terminate(); // Stop the worker in case of error
            };

            // Send data to the worker for compression
            worker.postMessage({ key, value, ttl });
        } else {
            reject(new Error('Web Workers are not supported in this browser.'));
        }
    });
};

/**
 * 
 * Get a locally stored item from localStorage with an expiry time
 * 
 * @param {string} key
 * @returns {array} value
 */
export const getWithExpiry = (key) => {

    // Get the locally stored item
    const stored_item = localStorage.getItem(key);

    // If the item doesn't exist, return null
    if (stored_item === null) return null;

    // Parse the item from storage
    const parsed_item = JSON.parse(stored_item);

    // compare the expiry time of the item with the current time
    if (new Date().getTime() > parsed_item.expiry || parsed_item.created < INVALIDATE_CACHE_CREATION_DATE) {

        console.log(`%c ${key} has expired`, 'color: #F9E2AF');

        // If the item is expired, delete the item from storage
        localStorage.removeItem(key);

        // Return null
        return false;
    }

    // If the item hasn't expired, return the saved items' value
    return LZString.decompressFromUTF16(parsed_item.value)
}
